import './inquiry.css';
import { Outlet } from 'react-router-dom';

const Inquiry = () => {
  return (
    <div>
      <Outlet></Outlet>
    </div>
  );
};

export default Inquiry;
